import {combineReducers} from 'redux'
import dashboardCountReducer from './dashboardCount';

export default combineReducers({
    dashboardCount: dashboardCountReducer,
})